<template>
  <div class="flex flex-1 flex-col">
    <BaseSpinner v-if="isLoading" />
    <div v-if="data?.data?.length" class="flex flex-col items-center justify-center py-4 bg-white">
      <Video
        :src="data.data[0].url"
        controls
        class="w-auto max-h-80 rounded-lg shadow-md"
      />
    </div>
    <div
      class="flex flex-1 items-center justify-center pt-4 space-x-2"
    >
      <router-link
        :to="{name: 'tutorial.tenant'}"
        active-class="border-primary text-primary font-semibold border-2 rounded-lg p-4"
        class="nav-item border-2 p-4 rounded-lg"
      >
        <div class="flex flex-row items-end gap-2">
          <User />
          Formation titulaire
        </div>
      </router-link>
      <router-link
        :to="{name: 'tutorial.team'}"
        active-class="border-primary text-primary font-semibold border-2 rounded-lg p-4"
        class="nav-item border-2 p-4 rounded-lg"
      >
        <div class="flex flex-row items-end gap-2">
          <Users />
          Formation équipe
        </div>
      </router-link>
    </div>
    <div class="h-full">
      <router-view :key="$route.path" />
    </div>
  </div>
</template>

<script setup lang="ts">
import {User, Users} from "@lucide/vue";
import BaseSpinner from "@/core/components/base/spinner/BaseSpinner.vue";
import useVideos from "@/video/composables/useVideos";

const {data, isLoading} = useVideos({
    limit: 1,
    tags: ['tutorial']
});
</script>
